import React, { Fragment } from 'react'
import Fade from 'react-reveal/Fade';
import Healthform from './Healthform';

function Banner() {
    return (
        <Fragment>
            <div className='container governancemain motor' >
                <div className='row arrticleAndBlogs'>
                    <div className='col-sm-12 heads govbanner claims'>
                        <Fade up delay={500}><h2 className="oswald">Claim Forms</h2></Fade>
                    </div>
                    <div className='col-sm-12 heads text mymaxheight'>
                       <Healthform/>
                    </div>                
                </div>
            </div>
        </Fragment>
    )
}

export default Banner